import React from 'react';
import { Pressable, Text, View, StyleSheet } from 'react-native';
import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons';

interface Props {
  whereLabel: string;
  whenLabel: string;
  whoLabel: string;
  onExpand: () => void;
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 10,
    marginLeft: -70,
    width: '100%' as any,
  },
  row: {
    flexWrap: 'wrap',
    flexDirection: 'row',
    alignItems: 'center',
    borderWidth: 1,
    borderRadius: 80,
    paddingHorizontal: 20,
    paddingVertical: 8,
    borderColor: 'lightgrey',
    backgroundColor: 'white',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.08,
    shadowRadius: 12,
    elevation: 5,
  },
  item: {
    paddingLeft: 10,
    marginRight: 25,
    flexDirection: 'row',
    alignItems: 'center',
  },
  itemText: {
    fontSize: 15,
    fontWeight: '500',
  },
  searchButton: {
    backgroundColor: '#3C8248',
    borderRadius: 20,
    width: 32,
    height: 32,
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: 12,
  },
});

const SearchBoxCollaposed: React.FC<Props> = ({ whereLabel, whenLabel, whoLabel, onExpand }) => {

  return (
    <View style={styles.container}>
      <View style={styles.row}>
        <Pressable style={styles.item} onPress={onExpand}>
          <Text style={styles.itemText}>{whereLabel}</Text>
          <MaterialCommunityIcons name={'map-marker-outline'} size={16} color={'#666'} style={{ marginLeft: 8 }} />
        </Pressable>
        <Pressable style={styles.item} onPress={onExpand}>
          <Text style={styles.itemText}>{whenLabel}</Text>
          <MaterialCommunityIcons name={'calendar-blank-outline'} size={16} color={'#666'} style={{ marginLeft: 8 }} />
        </Pressable>
        <Pressable style={styles.item} onPress={onExpand}>
          <Text style={styles.itemText}>{whoLabel}</Text>
          <MaterialCommunityIcons name={'account-outline'} size={16} color={'#666'} style={{ marginLeft: 8 }} />
        </Pressable>
        <Pressable style={styles.searchButton} onPress={onExpand}>
          <MaterialCommunityIcons name={'magnify'} size={16} color={'white'} />
        </Pressable>
      </View>
    </View>
  );
};

export default SearchBoxCollaposed; 